<template>
    <ul style="display: inherit">
        <li class="ghNav-item" @click="scrollToSection('event')"><a class="js-smoothScroll" href="#event">The Event</a></li>
        <li class="ghNav-item" @click="scrollToSection('speakers')" ><a class="js-smoothScroll" href="#speakers">Speakers</a></li>
        <li class="ghNav-item" @click="scrollToSection('sessions')"><a class="js-smoothScroll" href="#sessions">Sessions</a></li>
        <li class="ghNav-item" @click="scrollToSection('cpd-hours')"><a class="js-smoothScroll" href="#cpd-hours">CPD Credits</a></li>
        <li class="ghNav-item" @click="scrollToSection('faqs')"><a class="js-smoothScroll gh-nav" href="#faqs">FAQs</a></li>
        <li class="ghNav-item" @click="scrollToSection('registration')"><a class="js-smoothScroll" href="#registration">Register</a></li>
        <!--<li class="ghNav-item" @click="scrollToSection('registration')"><a class="js-smoothScroll" href="#registration">Register Now</a></li>-->
    </ul>
</template>
<script>
    import UX from '@/utils/ux';

    export default {
        methods: {
            scrollToSection(section) {
                const element = document.getElementById(section);

                element && UX.scrollTo(element);

                this.$emit('clicked');
            }
        }
    }
</script>
<style lang="scss" scoped>
    ul {
        padding: 1rem 1rem 2rem 2rem;
    }
    .ghNav-item {
        padding-top: 1rem;
        a {
            font-size: 1.25rem;
            font-weight: 600;
        }
    }
</style>
